import { createAction } from 'redux-actions';
import * as types from '../constants/actionTypes/canvasBlocks';

export const populateInitialBlocks = createAction(types.POPULATE_INITIAL_BLOCKS);
export const switchLockStructure = createAction(types.SWITCH_LOCK_STRUCTURE);
export const addBlock = createAction(types.ADD_BLOCK);
export const duplicateBlocks = createAction(types.DUPLICATE_BLOCKS);
export const removeBlock = createAction(types.REMOVE_BLOCK);
export const moveBlocks = createAction(types.MOVE_BLOCKS);
export const swapBlocks = createAction(types.SWAP_BLOCKS);
export const lockBlocks = createAction(types.LOCK_BLOCKS);
export const deleteBlocks = createAction(types.DELETE_BLOCKS);
export const updateBlocksProperties = createAction(types.UPDATE_BLOCKS_PROPERTIES);
